import React from 'react';
import DumbPrivacySettingButton from '../../dumpComponent/dumpPrivacyButton';

const PrivacySettingButton = (props) => {
    const { translate, clickHandler, useHyperLink } = props;

    const onClick = (e) => {
        if (useHyperLink) {
            e.preventDefault();
        }

        clickHandler();
    };

    return (
        <DumbPrivacySettingButton
            text={translate('LIVE_SEND_VIEWER_MY_PRIVACY_SETTINGS_TITLE')}
            useHyperLink={useHyperLink}
            onClick={onClick} />
    );
};

export default PrivacySettingButton;
